import {
  CheckedIcon,
  ErrorIcon,
  UncheckedIcon,
  WarningIcon,
} from "@src/assets";
import { FEES_ERROR_RATIO, FEES_WARNING_RATIO } from "@src/config";
import { useMemo } from "react";

interface Props {
  feesToTokenValueRatio: number;
  confirmed: boolean;
  setConfirmed: (confirmed: boolean) => void;
}

export const FeesWarningBanner = ({
  feesToTokenValueRatio,
  confirmed,
  setConfirmed,
}: Props) => {
  const isError = useMemo(
    () => feesToTokenValueRatio >= FEES_ERROR_RATIO,
    [feesToTokenValueRatio],
  );
  if (feesToTokenValueRatio < FEES_WARNING_RATIO) return null;

  return (
    <div
      className={`${
        isError ? "bg-error_color/10" : "bg-warning_color/10"
      } rounded-[12px] text-sm text-text_primary text-opacity-60 flex flex-col gap-4 p-4 text-left`}
    >
      <div className="flex gap-4 items-center">
        {isError ? (
          <ErrorIcon className="min-w-5 min-h-5 w-5 h-5" />
        ) : (
          <WarningIcon className="min-w-5 min-h-5 w-5 h-5" />
        )}
        <div>
          {`Fees exceed ${(feesToTokenValueRatio * 100).toFixed(
            2,
          )}% of the transaction amount due to current network congestion. `}
          {isError && "Try again later or choose another network."}
        </div>
      </div>
      {isError && (
        <label className="flex items-center select-none gap-2">
          <input
            type="checkbox"
            className="sr-only peer"
            checked={confirmed}
            onChange={(e) => setConfirmed(e.target.checked)}
          />

          <div
            className={`
            w-5 h-5
            flex items-center justify-center
            peer-focus-visible:outline-none peer-focus-visible:ring-2 peer-focus-visible:ring-black peer-focus-visible:rounded-sm
          `}
          >
            {confirmed ? <CheckedIcon /> : <UncheckedIcon />}
          </div>

          <span className="text-sm">
            I want to continue with this transaction
          </span>
        </label>
      )}
    </div>
  );
};
